import { httpRequest } from "@services/http";
import { ConsumerJourney } from "@models/population.model";

/** The consumer's journey addressed by population rather than campaign
 *  (MPN-1602) — same shape as the launch-scoped read, spanning every launch
 *  that targets the segment. Powers the data-file roster's expandable
 *  "Steps Taken" cell, which exists before and apart from any campaign. */
export class CommandGetSegmentConsumerJourney {
  async run(populationSegmentId: number, consumerId: number): Promise<ConsumerJourney> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/populations/${populationSegmentId}/consumers/${consumerId}/`;
    return await httpRequest<ConsumerJourney>(url, { method: "GET", cache: "no-store" });
  }
}
